import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { NumberInput } from "shared/ui/input/number/NumberInput"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface RoomPersonsNumberInputProps extends WithClassName {
  hideLabel?: boolean
}

export const RoomPersonsNumberInput = React.memo(
  ({ className, hideLabel }: RoomPersonsNumberInputProps) => {
    const { t } = useTranslation()
    const { isReadonly, isDisabled } = useRoomFormContext()

    return (
      <NumberInput.Root
        name="room.personsNumber"
        className={classNames("room-form__persons-number", className)}
        label={t("Room.personsNumber")}
        readonly={isReadonly}
        disabled={isDisabled}
        format={{ maximumFractionDigits: 0 }}
        step={1}
        data-testid="room__persons-number__input"
      >
        {!hideLabel && <NumberInput.Label />}
        <NumberInput.Group>
          <NumberInput.Decrement />
          <NumberInput.Focus>
            <NumberInput.Input />
          </NumberInput.Focus>
          <NumberInput.Increment />
        </NumberInput.Group>
        <NumberInput.Readonly />
        <NumberInput.ErrorMessage />
      </NumberInput.Root>
    )
  }
)
